import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import theme from '@/style';
import {downloadApk, useResponsiveDimensions} from '@/utils';
import React, {useMemo} from 'react';
import {ImageBackground, Image} from 'react-native';
import {inApp, inGameBox, isPWA} from '@/utils/interface';
import {stopBeforeDownload} from '@/utils/utils';

const Download: React.FC = () => {
  const [show, setShow] = React.useState(true);
  const toDownload = () => {
    if (stopBeforeDownload()) {
      return;
    }
    downloadApk();
  };
  const {width: screenWidth} = useResponsiveDimensions();
  const heightZoom = 56 / 375;
  const bannerHeight = screenWidth * heightZoom;
  const iconSize = (theme.iconSize.l * screenWidth) / 375;
  const margin = (theme.paddingSize.s * screenWidth) / 375;
  const _isPWA = useMemo(() => isPWA(), []);
  if (inApp || inGameBox || _isPWA) {
    return null;
  }
  return show ? (
    <ImageBackground
      resizeMode="cover"
      source={require('@assets/imgs/download.webp')}
      style={[
        theme.fill.fillW,
        theme.flex.row,
        theme.flex.centerByCol,
        {
          height: bannerHeight,
        },
      ]}>
      <NativeTouchableOpacity
        onPress={toDownload}
        style={[theme.flex.flex1, theme.fill.fillH]}
      />
      <NativeTouchableOpacity onPress={() => setShow(false)}>
        <Image
          style={[
            {
              height: iconSize,
              width: iconSize,
              marginHorizontal: margin,
            },
          ]}
          source={require('@assets/icons/close-white.webp')}
        />
      </NativeTouchableOpacity>
    </ImageBackground>
  ) : (
    <></>
  );
};

export default Download;
